const wizardComponentsHelper = require('../../utilities/wizardComponenstHelper');
const inputs = require('../inputs');

function buildWithoutActivity(prefix, authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    let grid = [[inputsFioc.your_job]];

    if (!authorized) {
        grid = [
            ...grid,
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'your_job',
                item: [
                    inputsFioc.capital_label,
                    inputsFioc.capital_work,
                    inputsFioc.capital_activities,
                    inputsFioc.capital_heritage,
                    inputsFioc.capital_business,
                    inputsFioc.capital_realState,
                    inputsFioc.capital_gambling,
                    inputsFioc.capital_other, {
                        id_component: 'condition-show',
                        id: 'show',
                        conditionType: 'single',
                        conditionId1: prefix + 'capital_other',
                        conditionValue1: true,
                        item: inputsFioc.capital_description
                    },
                    {
                        id_component: 'custom-error-message',
                        chekcIds: [
                            prefix + 'capital_work',
                            prefix + 'capital_activities',
                            prefix + 'capital_heritage',
                            prefix + 'capital_business',
                            prefix + 'capital_realState',
                            prefix + 'capital_gambling',
                            prefix + 'capital_other'
                        ],
                        msg_error: 'contractsView-listRequiredError'
                    },
                ]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionIds: [
                    prefix + 'capital_work',
                    prefix + 'capital_activities',
                    prefix + 'capital_heritage',
                    prefix + 'capital_business',
                    prefix + 'capital_realState',
                    prefix + 'capital_gambling',
                    prefix + 'capital_other'
                ],
                item: [
                    inputsFioc.income_origin_label,
                    inputsFioc.income_origin_tooltip,
                    inputsFioc.income_origin_benefits,
                    inputsFioc.income_origin_family_help,
                    inputsFioc.income_origin_financial_investments,
                    inputsFioc.income_origin_investment_property,
                    {
                        id_component: 'custom-error-message',
                        chekcIds: [
                            prefix + 'income_origin_benefits',
                            prefix + 'income_origin_family_help',
                            prefix + 'income_origin_financial_investments',
                            prefix + 'income_origin_investment_property',
                        ],
                        msg_error: 'contractsView-listRequiredError'
                    },
                ]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionIds: [
                    prefix + 'income_origin_benefits',
                    prefix + 'income_origin_family_help',
                    prefix + 'income_origin_financial_investments',
                    prefix + 'income_origin_investment_property',
                ],
                item: inputsFioc.has_pep
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'single',
                conditionId1: prefix + 'has_pep',
                conditionValue1: 1,
                item:
                    [inputsFioc.has_pep_details]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'has_pep',
                item: [inputsFioc.operationsLabel]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'operations_account',
                item: [inputsFioc.account_use_2]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'or',
                conditionId1: prefix + 'account_use_2',
                conditionValue1: 2,
                conditionId2: prefix + 'account_use_2',
                conditionValue2: 3,
                item: [
                    inputsFioc.account_use_operation_label,
                    inputsFioc.operations_dangerous_countries,
                    inputsFioc.checks_holder,
                    inputsFioc.checks_traveler,
                    inputsFioc.delivery_or_cash_withdrawals,
                    inputsFioc.buying_and_selling_foreing_banknotes,
                    inputsFioc.payment_orders_or_collection_abroad,
                    inputsFioc.foreing_trade_operations,
                    inputsFioc.none_of_the_above,
                    {
                        id_component: 'custom-error-message',
                        chekcIds: [
                            prefix + 'operations_dangerous_countries',
                            prefix + 'checks_holder',
                            prefix + 'checks_traveler',
                            prefix + 'delivery_or_cash_withdrawals',
                            prefix + 'buying_and_selling_foreing_banknotes',
                            prefix + 'payment_orders_or_collection_abroad',
                            prefix + 'foreing_trade_operations',
                            prefix + 'none_of_the_above'
                        ],
                        msg_error: 'contractsView-listRequiredError'
                    }
                ]
            }],
            [{
                id_component: 'condition-show',
                id: 'show',
                conditionType: 'ifPrevIsComplete',
                conditionId1: prefix + 'account_use_2',
                item: [inputsFioc.foreingTax]
            }]
        ];
    }

    return {
        id_component: 'condition-show',
        id: 'show',
        conditionType: 'single',
        conditionId1: prefix + 'fioc_ocupation',
        conditionValue1: 4,
        item: {
            id_component: 'fioc',
            id: prefix + 'fioc_pensioner',
            exclude: [],
            grid
        }
    }
}

module.exports = buildWithoutActivity;
